import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPlansById } from "../../actions/plans";
import { useParams } from "react-router-dom";
import { DynamicBanner } from "../../components/DynamicBanner";
import { StaticBanner } from "../../components/StaticBanner";
import { ActionsSection } from "../sections/ActionsSection";
import { ContactSection } from "../sections/ContactSection";
import { FaqSection } from "../sections/FaqSection";
import { GuidesSection } from "../sections/GuidesSection";
import { HelpSection } from "../sections/HelpSection";
import { TabsSection } from "../sections/TabsSection";
import styles from "./styles";
import { CircularProgress } from "@material-ui/core";
import { getItemFromArrayJsonPosition } from "../../utils/utilFunctions";
import { Error404 } from "../../components/Error404";

export const PlanPage = () => {
  const classes = styles();
  const dispatch = useDispatch();
  const { plan } = useSelector(state => state.plans);
  const { planId } = useParams();

  const [loadingPage, setloadingPage] = useState(true);

  let bannerUrl;
  let cardImage;

  const fetchData = async () => {
    await dispatch(getPlansById(planId));
    setloadingPage(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData();
  }, []);

  if (!loadingPage && plan) {
    bannerUrl = getItemFromArrayJsonPosition(plan.images, "type", "banner");
    cardImage = getItemFromArrayJsonPosition(plan.images, "type", "card");
  }

  return !loadingPage ? (
    plan ? (
      <div className={classes.mainContainer}>
        <div>
          <DynamicBanner
            bannerUrl={bannerUrl ? bannerUrl.url : ""}
            cardImage={cardImage ? cardImage.url : ""}
            title={plan ? plan.name : ""}
            description={plan ? plan.description : ""}
          />
        </div>
        <div>
          <ActionsSection />
        </div>
        <div>
          <TabsSection
            sections={plan ? plan.sections : []}
            type={plan ? plan.type : {}}
          />
        </div>
        <div>
          <FaqSection questions={plan ? plan.questions : []} />
        </div>
        <div>
          <GuidesSection files={plan ? plan.files : []} />
        </div>
        <div>
          <ContactSection />
        </div>
      </div>
    ) : (
      <div className={classes.error404Section}>
        <Error404 />
      </div>
    )
  ) : (
    <div>
      <div style={{ minHeight: "90vh" }}></div>
      <CircularProgress
        color="primary"
        style={{
          position: "fixed",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          margin: "auto",
          zIndex: 99
        }}
      />
    </div>
  );
};
